import React from 'react';

import { useAppSelector } from '../../../../components/hooks';
import { GenericFeatureAreaVisual } from './GenericFeatureAreaVisual';

export function InsertionFeatureAreaVisual() {
  const insertionInfo = useAppSelector((state) =>
    state.application.insertingObjectInfo?.type === 'featureArea' ? state.application.insertingObjectInfo.data : null,
  );

  const container = useAppSelector((state) =>
    insertionInfo ? state.layout.featurePatternContainers[insertionInfo.featurePatternContainerGuid] : null,
  );

  if (insertionInfo == null || container == null) return null;

  return <GenericFeatureAreaVisual style="featureArea.emphasised" container={container} area={insertionInfo.value} />;
}
